import { createSlice } from "@reduxjs/toolkit";
import { resetPatientData } from "../../../system/store/reset.slice";

const initialState = {
  data: null,
};

export const documentsSlice = createSlice({
  name: "entities/patient-stats/documents-slice",
  initialState,
  reducers: {
    setDocuments: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPatientData, () => initialState);
  },
});

export const { setDocuments } = documentsSlice.actions;

export default documentsSlice.reducer;
